import {SYMPTOM_CHECKER_HISTORY_URL, VITALS_HISTORY_URL, STREAKS_URL} from './constants';
import useAxios from '../hooks/useAxios';

/**
 * Hook for interacting with the Dashboard API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useDashboardApi = () => {
  const api = useAxios();

  /**
   * Gets the list of symptom checker history.
   *
   * @returns {Promise} A Promise that resolves with the symptom checker history data.
   */
  const getSymptomCheckerHistoryList = () => api.get(`${SYMPTOM_CHECKER_HISTORY_URL}`);

  /**
   * Gets the list of vitals history.
   *
   * @returns {Promise} A Promise that resolves with the vitals history data.
   */
  const getVitalsHistoryList = () => api.get(VITALS_HISTORY_URL);

  /**
   * Gets the streak information.
   *
   * @returns {Promise} A Promise that resolves with the streak data.
   */
  const getStreak = () => api.get(STREAKS_URL);

  return {
    getSymptomCheckerHistoryList,
    getVitalsHistoryList,
    getStreak,
  };
};
